 
import { apiUrl } from "../../../config";
import axios from "axios";

export const state = {
  ListeExpertAssure : [],
  ExpertAssurance : {
     // Declare des le depart : l'API renvoie l'id de la fiche PROPRE AU
     // DOSSIER (une copie du modele choisi dans la liste), et Vue 2 ne rend
     // pas reactive une propriete ajoutee apres coup.
     id : null,
     cabinet : null,
     nom : null ,
     prenom : null,
     email : null,
     rue : null,
     cp : null,
     ville:null, 
     tel:null, 
     numero_adresse:null,
     ref:null,
     nom_assistante:null,
      prenom_assistante:null,
      email_assistante:null,
      tel_assistante:null,
  },
  ExpertAssurre : {
    cabinet : null,
    nom : null ,
    prenom : null,
    email : null,
    rue : null,
    cp : null,
    ville:null, 
    tel:null, 
    numero_adresse:null,
    ref:null,
    nom_assistante:null,
    prenom_assistante:null,
    email_assistante:null,
    tel_assistante:null,
    role:null,
    error:false,
    error_assistante:false
  },
  Assurance : {
    // Voir ExpertAssurance.id ci-dessus : id de la fiche du dossier.
    id: null,
    lib: null,
    ref: null,
    rue: null,
    email: null,
    cp: null,
    ville: null,
    tel: null,
    numero_adresse:null,
    police:null
  },
  SelectAssurance : [],
  selectsearchAssurance : [],
  selectsearchExpertAssurance : []
};

export const mutations = {

    update_ASSURANCE(state,value){
        let index = state.Assurance.findIndex(ass => ass.id === value.id);
        state.Assurance.splice(index,1,value)
    },
    delete_ASSURANCE(state,value){
        let index = state.Assurance.findIndex(ass => ass.id === value.id);
        state.Assurance.splice(index,1)
    },
    RESET_ASSURANCE(state) {
        state.Assurance=[];
        state.SelectAssurance=[];
     },
    ADD_ASSURANCE(state, newValue) {
        state.Assurance=(newValue);
        // const select = {text :newValue.lib , value : newValue.id}
        // state.SelectAssurance.push(select);
    },

    SET_ASSURANCE(state, newValue) {
        state.Assurance= newValue;
        
    },
    SET_EXPERT_ASSURANCE(state, newValue) {
      state.ExpertAssurance= newValue;
    },

    RESET_EXPERT_ASSURANCE(state) {
      state.ExpertAssurance={
        cabinet : null,
        nom : null ,
        prenom : null,
        email : null,
        rue : null,
        cp : null,
        ville:null, 
        tel:null, 
     }
    },
    RESET_EXPERT_ASSURRE(state) {
      state.ListeExpertAssure=[]
      state.ExpertAssurre={
        cabinet : null,
        nom : null ,
        prenom : null,
        email : null,
        rue : null,
        cp : null,
        ville:null, 
        tel:null, 
     }
    },
    SET_EXPERT_ASSURRE(state, newValue) {
      //state.ExpertAssurre= newValue;
      state.ListeExpertAssure.push(newValue)
    },

    REMOVE_EXPERT_ASSURRE(state, index) {
      if (index >= 0 && index < state.ListeExpertAssure.length) {
        state.ListeExpertAssure.splice(index, 1)
      }
    },
    
    // après une sauvegarde : complète la ligne locale (id + champs vides) sans la remplacer,
    // pour ne pas perdre la saisie en cours ni casser la référence de l'objet lié au template
    update_EXPERT_ASSURRE(state,payload){
      const value = (payload && payload.value !== undefined) ? payload.value : payload;
      if (!value) return;
      let index = (payload && typeof payload.index === "number") ? payload.index : -1;
      if (index >= 0 && index < state.ListeExpertAssure.length) {
        const candidate = state.ListeExpertAssure[index];
        if (candidate.id != null && candidate.id !== value.id) {
          index = -1;
        }
      } else {
        index = -1;
      }
      if (index === -1) {
        index = state.ListeExpertAssure.findIndex(ass => ass.id === value.id);
      }
      if (index === -1) {
        index = state.ListeExpertAssure.findIndex(ass => ass.id == null);
      }
      if (index === -1) {
        state.ListeExpertAssure.push(value);
        return;
      }
      const row = state.ListeExpertAssure[index];
      Object.keys(value).forEach((key) => {
        if (row[key] == null || row[key] === "") {
          row[key] = value[key];
        }
      });
  },

  MERGE_ASSURANCE_SAVED(state, newValue) {
    if (!newValue) return;
    Object.keys(newValue).forEach((key) => {
      if (state.Assurance[key] == null || state.Assurance[key] === "") {
        state.Assurance[key] = newValue[key];
      }
    });
  },

  MERGE_EXPERT_ASSURANCE_SAVED(state, newValue) {
    if (!newValue) return;
    Object.keys(newValue).forEach((key) => {
      if (state.ExpertAssurance[key] == null || state.ExpertAssurance[key] === "") {
        state.ExpertAssurance[key] = newValue[key];
      }
    });
  },

  SET_SELECT_SEARCH(state,newValue){
    state.selectsearchAssurance=[]
    newValue.forEach((element) => {
       
      state.selectsearchAssurance.push(element)
    });
   
  },
  RESET_SELECT_SEARCH(state){
    state.selectsearchAssurance=[]
   
  },

  SET_SELECT_EXPERT_ASSURANCE_SEARCH(state,newValue){
    state.selectsearchExpertAssurance=[]
    newValue.forEach((element) => {
       
      state.selectsearchExpertAssurance.push(element)
    });
   
  },
  RESET_SELECT_EXPERT_ASSURANCE_SEARCH(state){
    state.selectsearchExpertAssurance=[]
   
  },

   
  NOTHING() {},
};

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return !!state.currentUser;
  },
  Assurance(state) {
    return state.Assurance;
  },
  ExpertAssurance(state) {
    return state.ExpertAssurance;
  },
  ExpertAssurre(state) {
    return state.ExpertAssurre;
  },
  SelectAssurance(state) {
    return state.SelectAssurance;
  },
  ListeExpertAssure(state) {
    return state.ListeExpertAssure;
  },
  SelectSearchListeAssurance(state) {
    return state.selectsearchAssurance;
  },
  SelectSearchListeExpertAssurance(state) {
    return state.selectsearchExpertAssurance;
  },
  
  
};

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  // eslint-disable-next-line no-unused-vars
  init({ state, dispatch }) {
    dispatch("validate");
  },

 

  
  
  
  createAssurance({ commit }, { id,data } = {}) {
    //delete data['email']
     
    return new Promise((resolve, reject) => {
      axios
        .post(apiUrl + "api/assurance/"+id, data, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("auth"),
          },
        })
        .then((response) => {


          commit("MERGE_ASSURANCE_SAVED",response.data.data);
          // commit("SET_TOKEN_USER",response.data.data.token)
          resolve(true);
        })
        .catch((e) => {
          console.log(e);
          reject(e);
          //Vue.$notify('error filled', 'Erreur', e, { duration: 3000, permanent: false });
        });
    });
  },

  getAssurance({ commit },{id}) {

    return new Promise((resolve, reject) => {
      axios
        .get(apiUrl + "api/assurance/"+id, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("auth"),
          },
        })
        .then((response) => {
            commit("RESET_ASSURANCE");

          let data=response.data.data

          console.log('ici data assurance=',data)
            commit("ADD_ASSURANCE",data);
          
          // commit("SET_TOKEN_USER",response.data.data.token)
          resolve(true);
        })
        .catch((e) => {
          console.log(e);
          reject(e);
          //Vue.$notify('error filled', 'Erreur', e, { duration: 3000, permanent: false });
        });
    });
  },
  updateAssurance({ commit }, { data } = {}) {
    //delete data['email']
     
    return new Promise((resolve, reject) => {
      axios
        .put(apiUrl + "api/assurance/"+data.id, data, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("auth"),
          },
        })
        .then((response) => {
          
          commit("update_ASSURANCE",response.data.data);
          // commit("SET_TOKEN_USER",response.data.data.token)
          resolve(true);
        })
        .catch((e) => {
          console.log(e);
          reject(e);
          //Vue.$notify('error filled', 'Erreur', e, { duration: 3000, permanent: false });
        });
    });
  },
  deleteAssurance({ commit }, { data } = {}) {
    //delete data['email']
     
    return new Promise((resolve, reject) => {
      axios
        .delete(apiUrl + "api/assurance/"+data.id ,  {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("auth"),
          },
        })
        .then(( ) => {
           
          commit("delete_ASSURANCE",data);
          // commit("SET_TOKEN_USER",response.data.data.token)
          resolve(true);
        })
        .catch((e) => {
          console.log(e);
          reject(e);
          //Vue.$notify('error filled', 'Erreur', e, { duration: 3000, permanent: false });
        });
    });
  },
 /**search assurance */
 getAssuranceBySearch({ commit },{ search } = {}) {
 
  return  axios .get(apiUrl + "api/assurance?search="+search, {
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("auth"),
        },
      })
      .then((response) => {
        if(response.data && response.data.data){
          commit("SET_SELECT_SEARCH",response.data.data);
        }else{
          commit("RESET_SELECT_SEARCH" );
        }
       
        // console.log('ici response',response.data)
        // return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e);
        //Vue.$notify('error filled', 'Erreur', e, { duration: 3000, permanent: false });
      });
  
},

  RESETASSURANCE({ commit }){
    commit("RESET_SELECT_SEARCH" );
  },
  RESETEXPERTASSURANCE({ commit }){
    commit("RESET_SELECT_EXPERT_ASSURANCE_SEARCH" );
  },


  
  // Rattache une compagnie au dossier. Le serveur ne relie PAS le dossier a
  // la fiche choisie : il lui en fabrique une copie, pour qu'une correction
  // sur ce dossier n'atteigne jamais les autres. Il renvoie donc la fiche
  // reellement rattachee, dont l'id doit remplacer celui de la suggestion.
  updateAssuranceDossier({ commit }, { id,assurance } = {}) {
    return new Promise((resolve, reject) => {
      axios
        .post(apiUrl + "api/setAssurance/"+id+"/"+assurance, [], {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("auth"),
          },
        })
        .then((response) => {
          commit('NOTHING')
          resolve(response.data.data)
        })
        .catch((e) => {
          console.log(e);
          reject(e);
          //Vue.$notify('error filled', 'Erreur', e, { duration: 3000, permanent: false });
        });
    });
  },


  // Idem updateAssuranceDossier : le serveur renvoie la copie rattachee au
  // dossier, pas la fiche modele choisie dans la liste.
  updateExpertAssuranceDossier({ commit }, { id,assurance } = {}) {
    return new Promise((resolve, reject) => {
      axios
        .post(apiUrl + "api/setExpertAssurance/"+id+"/"+assurance, [], {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("auth"),
          },
        })
        .then((response) => {
          commit('NOTHING')
          resolve(response.data.data)
        })
        .catch((e) => {
          console.log(e);
          reject(e);
          //Vue.$notify('error filled', 'Erreur', e, { duration: 3000, permanent: false });
        });
    });
  },
   /**search assurance */
 getExpertAssuranceBySearch({ commit },{ search } = {}) {
 
  return  axios .get(apiUrl + "api/expert-assurance?search="+search, {
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("auth"),
        },
      })
      .then((response) => {
        if(response.data && response.data.data){
          commit("SET_SELECT_EXPERT_ASSURANCE_SEARCH",response.data.data);
        }else{
          commit("RESET_SELECT_EXPERT_ASSURANCE_SEARCH" );
        }
       
        // console.log('ici response',response.data)
        // return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e);
        //Vue.$notify('error filled', 'Erreur', e, { duration: 3000, permanent: false });
      });
  
},
  getExpertAssurance({ commit },{id}) {

    return new Promise((resolve, reject) => {
      axios
        .get(apiUrl + "api/expert-assurance/"+id, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("auth"),
          },
        })
        .then((response) => {
            commit("RESET_EXPERT_ASSURANCE");

          let data=response.data.data

        
            commit("SET_EXPERT_ASSURANCE",data);
          
          // commit("SET_TOKEN_USER",response.data.data.token)
          resolve(true);
        })
        .catch((e) => {
          console.log(e);
          reject(e);
          //Vue.$notify('error filled', 'Erreur', e, { duration: 3000, permanent: false });
        });
    });
  }, 
  getExpertAssurre({ commit },{id}) {

    return new Promise((resolve, reject) => {
      axios
        .get(apiUrl + "api/expert-assure/"+id, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("auth"),
          },
        })
        .then((response) => {
            commit("RESET_EXPERT_ASSURRE");

          let data=response.data.data

          data.forEach(element => {
            commit("SET_EXPERT_ASSURRE",element);
          });
     
          
          
          // commit("SET_TOKEN_USER",response.data.data.token)
          resolve(true);
        })
        .catch((e) => {
          console.log(e);
          reject(e);
          //Vue.$notify('error filled', 'Erreur', e, { duration: 3000, permanent: false });
        });
    });
  },

  createExpertAssurance({ commit }, { id,data } = {}) {
    //delete data['email']
     
    return new Promise((resolve, reject) => {
      axios
        .post(apiUrl + "api/expert-assurance/"+id, data, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("auth"),
          },
        })
        .then((response) => {
            

          commit("MERGE_EXPERT_ASSURANCE_SAVED",response.data.data);
          // commit("SET_TOKEN_USER",response.data.data.token)
          resolve(true);
        })
        .catch((e) => {
          console.log(e);
          reject(e);
          //Vue.$notify('error filled', 'Erreur', e, { duration: 3000, permanent: false });
        });
    });
  },
  createExpertAssurre({ commit }, { id,data,index } = {}) {
    //delete data['email']

    return new Promise((resolve, reject) => {
      axios
        .post(apiUrl + "api/expert-assure/"+id, data, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("auth"),
          },
        })
        .then((response) => {


          commit("update_EXPERT_ASSURRE",{ value: response.data.data, index: index });
          // commit("SET_TOKEN_USER",response.data.data.token)
          resolve(true);
        })
        .catch((e) => {
          console.log(e);
          reject(e);
          //Vue.$notify('error filled', 'Erreur', e, { duration: 3000, permanent: false });
        });
    });
  },

  // Retire un intervenant (DELETE si déjà en base, sinon retrait local)
  deleteExpertAssurre({ commit }, { data, index } = {}) {
    return new Promise((resolve, reject) => {
      if (data == null || data.id == null) {
        commit("REMOVE_EXPERT_ASSURRE", index)
        resolve(true)
        return
      }
      axios
        .delete(apiUrl + "api/expert-assure/" + data.id, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("auth"),
          },
        })
        .then(() => {
          commit("REMOVE_EXPERT_ASSURRE", index)
          resolve(true)
        })
        .catch((e) => {
          console.log(e)
          reject(e)
        })
    })
  },

  add_exprtAssurre({commit}){

     
    const newAsurer={
      cabinet : null,
      nom : null ,
      prenom : null,
      email : null,
      rue : null,
      cp : null,
      ville:null, 
      tel:null, 
      numero_adresse:null,
      ref:null,
      nom_assistante:null,
      prenom_assistante:null,
      email_assistante:null,
      tel_assistante:null,
      id:null,
      role:null
    }
    commit("SET_EXPERT_ASSURRE",newAsurer);
     
  }
};

// ===
// Private helpers
// ===

// function saveState(key, state) {
//     window.localStorage.setItem(key, JSON.stringify(state))
// }
